import { useState, useEffect } from "react";
import Link from "next/link";
import { getProductURL } from "@services/product";
import { getShopifyNextImage } from "@lib/getImages";
import { formattedPrice } from "../lib/textFormatters";
import styles from "./styles/LineItem.module.css";

export const LineItem = ({ item }) => {
  const [query, setQuery] = useState(null);

  useEffect(() => {
    let mounted = true;

    const fetchQuery = async () => {
      const product = await getProductURL(item.variant.product.handle, item.variant);
      if (product && mounted) setQuery(product.url);
    };

    if (item.variant) {
      fetchQuery();
    }

    return () => {
      mounted = false;
      setQuery(null)
    };
  }, []);

  const { title, quantity, discountedTotalPrice, originalTotalPrice, variant } = item;

  const selectedOptions = variant ? variant.selectedOptions : [];
  const image = variant ? variant.image : null;

  const size = selectedOptions.find((option) => option.name === "Size");
  const price = originalTotalPrice.amount / quantity;
  const priceWithDiscount = discountedTotalPrice.amount / quantity;
  const hasDiscount =
    parseFloat(discountedTotalPrice.amount) < parseFloat(originalTotalPrice.amount);

  const NextImage = ({ title, image }) => {
    return getShopifyNextImage(
      image.originalSrc,
      48,
      64,
      `(max-width: 3rem) 48, (max-width: 3rem) 48, 48`,
      `Image of ${title}`,
      image.placeholder
    );
  };

  const LinkableItem = ({ children }) => {
    if (query && query.slug) {
      return (
        <Link href={{ pathname: "/products/[slug]", query }}>
          <a>{children}</a>
        </Link>
      );
    }

    return <>{children}</>;
  };

  const Image = () => {
    return (
      <div className={styles.productImg}>
        {!image && (
          <div className={styles.placeholderImg}>
            <p>Image missing</p>
          </div>
        )}

        {image && (
          <LinkableItem>
            <NextImage title={title} image={image} />
          </LinkableItem>
        )}
      </div>
    );
  };

  const Title = () => {
    return (
      <div>
        <LinkableItem>
          <p className={styles.productTitle}>{title}</p>
        </LinkableItem>
        <p className={styles.hideMobile}>Size {size && size.value ? size.value : "n/a"}</p>
        <p className={styles.showMobile}>
          Size {size && size.value ? size.value : "n/a"}, x {quantity},{" "}
          {formattedPrice(discountedTotalPrice.amount)}
        </p>
      </div>
    );
  };

  const Quantity = () => {
    return (
      <>
        {hasDiscount && (
          <div className={styles.hideMobile}>
            <p>
              {formattedPrice(priceWithDiscount)} x {quantity}
            </p>
            <p className={styles.strikeThrough}>{formattedPrice(price)}</p>
          </div>
        )}

        {!hasDiscount && (
          <p className={styles.hideMobile}>
            {formattedPrice(price)} x {quantity}
          </p>
        )}
      </>
    );
  };

  const Price = () => {
    return <p className={styles.hideMobile}>{formattedPrice(discountedTotalPrice.amount)}</p>;
  };

  const LinkToItem = () => {
    return (
      <LinkableItem>
        <p className={styles.viewItem}>View Item</p>
      </LinkableItem>
    );
  };

  return (
    <li className={styles.lineItem}>
      <div className={styles.lineItemInfo}>
        <Image />
        <Title />
        <Quantity />
        <Price />
      </div>
      {query && query.slug && <LinkToItem />}
    </li>
  );
};
